import apiClient from './client'

// Venditori CRUD
export const getVenditori = (params) => apiClient.get('/users/venditori/', { params })
export const getVenditore = (id) => apiClient.get(`/users/venditori/${id}/`)
export const createVenditore = (data) => apiClient.post('/users/venditori/', data)
export const updateVenditore = (id, data) => apiClient.patch(`/users/venditori/${id}/`, data)
export const deleteVenditore = (id) => apiClient.delete(`/users/venditori/${id}/`)

// Ricerca venditori (per autocomplete)
export const searchVenditori = (search) => apiClient.get('/users/venditori/', { 
  params: { search, attivo: true } 
})

export default {
  getVenditori,
  getVenditore,
  createVenditore,
  updateVenditore,
  deleteVenditore,
  searchVenditori,
}
